module.exports = __webpack_public_path__ + "static/img/loading-nobg.c7673a5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading-nobg.gif
// module id = Xe9j
// module chunks = 281